import gql from "graphql-tag"

const fullCreationMetadata = gql`
fragment fullCreationMetadata on BusinessCreationMetadata {
  businessId
  createdById
  createdBy {
    uuid
    email
    fullName
  }
  createdAt
  reasonForCreation
  details
}
`
export default fullCreationMetadata
